import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import RadioBoxGroupViewModelType from '@/ViewModels/Controls/RadioBoxGroupViewModel';

export default class RadioBoxGroup extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: RadioBoxGroupViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div></div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'radioboxgroup',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            locator: this.viewModel.locator,

            visible: this.viewModel.isVisible,

            states: this.definePureComputed(() => {
                let states = [];

                if (this.viewModel.isRequired() === true) {
                    states.push('required');
                }

                if (this.viewModel.isValid() === true) {
                    states.push('valid');
                } else {
                    states.push('invalid');
                }

                if (this.viewModel.isEnabled() === true) {
                    states.push('enabled');
                } else {
                    states.push('disabled');
                }

                states.push(this.viewModel.orientation);

                return states;
            }),

            radioBox: {
                parent: this,

                items: this.viewModel.items
            }
        });

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('RadioBoxGroup', RadioBoxGroup, 'RADPresentation.HTMLClient.DefaultViewExtensions');